module.exports = __webpack_public_path__ + "img/GAME_BEAUTIFULFLOWER1.0da620a4.jpg";